module.exports = __webpack_public_path__ + "assets/computer-bg.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/computer-bg.jpg
// module id = 1216
// module chunks = 7